import axios, { AxiosInstance } from "axios";

export const createApiClient = (baseURL: string): AxiosInstance => {
  const axiosInstance = axios.create({
    baseURL,
  });

  return axiosInstance;
};
